import type { FC, ReactNode } from "react";
import type { CurrentWorkspace, User } from "../AuthProvider";
import { AuthorizedUserContext } from "./context";

export const AuthorizedUserProvider: FC<{
  children: ReactNode;
  currentUser: User;
  currentWorkspace: CurrentWorkspace;
}> = ({ children, currentUser, currentWorkspace }) => {
  return (
    <AuthorizedUserContext.Provider value={{ currentUser, currentWorkspace }}>
      {children}
    </AuthorizedUserContext.Provider>
  );
};
